import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { syncDocumentLanguage } from './helpers/document-language';

i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .on('languageChanged', syncDocumentLanguage)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        supportedLngs: ["en", "es"],
        fallbackLng: "en",
        load: "languageOnly",
        ns: ["translation", "admin"],
        backend: {
            // The locale files are static assets that browsers and CDNs cache. Without a version in the
            // URL a new release serves a fresh bundle against stale JSON, and new keys render raw.
            loadPath: "/locales/{{lng}}/{{ns}}.json?v=" + (process.env.REACT_APP_BUILD_ID || "dev"),
        },
        defaultNS: "translation",
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);

export default i18n;
